import Vue from 'vue'

const state = {
};

const mutations = {
};

const actions = {
  sendAction: ({commit}, action) => {
    return Vue.http.post('webstore/action', action)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        return data;
      });
  }
};

const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sendLog.js